/* ARCHADIA NOIR — global behaviours */
(function () {
  'use strict';

  function formatMoney(cents) {
    var format = (window.AN && window.AN.moneyFormat) || 'Rs. {{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]*>/g, '').trim();
  }
  function formatMoneyShort(cents) {
    return formatMoney(cents).replace(/\.00($|\s)/, '$1');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  window.ANmoney = formatMoney;

  /* ---- Reveal on scroll ---- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.is-in), .reveal-stagger:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- Videos ---- */
  function initVideos() {
    document.querySelectorAll('video').forEach(function (v) {
      if (!v.hasAttribute('autoplay')) return;
      v.muted = true; v.setAttribute('muted', '');
      v.playsInline = true; v.setAttribute('playsinline', '');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.target.paused) {
            var p = en.target.play(); if (p && p.catch) p.catch(function () {});
          }
        });
      }, { threshold: 0.2 });
      document.querySelectorAll('video[autoplay]').forEach(function (v) { vio.observe(v); });
    }
  }

  /* ---- Header ---- */
  function initHeader() {
    var header = document.querySelector('.header');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var burger = document.querySelector('[data-burger]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (burger && nav) {
      burger.addEventListener('click', function () {
        nav.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        burger.setAttribute('aria-expanded', 'true');
      });
      document.querySelectorAll('[data-nav-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          nav.classList.remove('is-open');
          document.body.style.overflow = '';
          burger.setAttribute('aria-expanded', 'false');
        });
      });
      nav.querySelectorAll('a').forEach(function (el) {
        el.addEventListener('click', function () {
          nav.classList.remove('is-open');
          document.body.style.overflow = '';
          burger.setAttribute('aria-expanded', 'false');
        });
      });
    }
  }

  /* ---- Marquee ---- */
  function initMarquee() {
    document.querySelectorAll('.marquee__track').forEach(function (track) {
      if (track.getAttribute('data-marquee-cloned')) return;
      track.innerHTML += track.innerHTML;
      track.setAttribute('data-marquee-cloned', '1');
    });
  }

  /* ---- Carousels ---- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel-wrap]').forEach(function (wrap) {
      var track = wrap.querySelector('.carousel');
      if (!track) return;
      wrap.querySelectorAll('[data-car-prev]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
      });
      wrap.querySelectorAll('[data-car-next]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
      });
    });
  }

  /* ---- Make entire product cards clickable (fixes dead clicks on homepage/collection) ---- */
  function initCardClicks(root) {
    (root || document).querySelectorAll('.card').forEach(function (card) {
      /* Skip if already wired or card itself is an anchor */
      if (card.getAttribute('data-card-wired') || card.tagName === 'A') return;
      var link = card.querySelector('a.card__link');
      if (!link) return;
      card.style.cursor = 'pointer';
      card.setAttribute('data-card-wired', '1');
      card.addEventListener('click', function (e) {
        /* Don't hijack clicks on interactive elements inside the card */
        if (e.target.closest('a, button, input, select, [data-atc]')) return;
        window.location.href = link.href;
      });
    });
  }

  /* ---- Cart drawer + floating bubble ---- */
  var drawer, overlay;
  var cartFloat = null;
  var busyLines = {};

  function updateCartFloat(cart) {
    if (!cartFloat) cartFloat = document.querySelector('[data-cart-float]');
    if (!cartFloat) return;
    var has = cart && cart.item_count > 0;
    var countEl = cartFloat.querySelector('[data-cart-float-count]');
    var priceEl = cartFloat.querySelector('[data-cart-float-price]');
    var announcer = document.querySelector('[data-cart-announcer]');
    if (countEl) countEl.textContent = has ? cart.item_count : '0';
    if (priceEl) priceEl.textContent = has ? formatMoneyShort(cart.total_price) : '';
    cartFloat.classList.toggle('is-visible', has);
    cartFloat.setAttribute('aria-hidden', has ? 'false' : 'true');
    if (announcer && has) {
      announcer.textContent = 'Cart: ' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ', ' + formatMoneyShort(cart.total_price);
    }
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open'); overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cart-is-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('cart-is-open');
  }
  window.ANopenCart = openDrawer;

  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function renderCart(cart) {
    if (!cart) return;
    var items = document.querySelector('[data-cart-items]');
    var empty = document.querySelector('[data-cart-empty]');
    var foot = document.querySelector('[data-cart-foot]');
    var st = document.querySelector('[data-cart-subtotal]');
    var stb = document.querySelector('[data-cart-subtotal-btn]');
    var dc = document.querySelector('[data-cart-count-drawer]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var has = cart.item_count > 0;
    if (items) {
      items.hidden = !has;
      if (has) {
        var html = '';
        cart.items.forEach(function (it, i) {
          var line = i + 1;
          html += '<div class="cart-line" data-line-el="' + line + '"><a href="' + esc(it.url) + '">' +
            (it.image ? '<img src="' + esc(imgUrl(it.image, 128)) + '" alt="' + esc(it.product_title) + '" width="64" height="80" loading="lazy">' : '') +
            '</a><div><p class="cart-line__title">' + esc(it.product_title) + '</p>' +
            (it.variant_title && it.variant_title.indexOf('Default') === -1 ? '<p class="cart-line__meta">' + esc(it.variant_title) + '</p>' : '') +
            '<div class="cart-line__controls"><div class="qty">' +
            '<button type="button" data-qty-change data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button>' +
            '<input type="text" value="' + it.quantity + '" readonly aria-label="Quantity" data-qty-input data-line="' + line + '">' +
            '<button type="button" data-qty-change data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div><a href="#" class="cart-line__remove" data-line-remove data-line="' + line + '">Remove</a></div></div>' +
            '<div class="cart-line__price" data-line-price="' + line + '">' + esc(formatMoney(it.final_line_price)) + '</div></div>';
        });
        items.innerHTML = html;
      } else { items.innerHTML = ''; }
    }
    if (empty) empty.hidden = has;
    if (foot) foot.hidden = !has;
    if (st) st.textContent = formatMoney(cart.total_price);
    if (stb) stb.textContent = formatMoneyShort(cart.total_price);
    if (dc) dc.textContent = cart.item_count;
    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    updateCartFloat(cart);
    busyLines = {};
  }

  function fetchCart() {
    return fetch('/cart.js?t=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  window.ANrefreshCart = fetchCart;

  function optimisticQty(line, newQty) {
    var input = document.querySelector('[data-qty-input][data-line="' + line + '"]');
    if (input) input.value = newQty;
    var priceEl = document.querySelector('[data-line-price="' + line + '"]');
    if (priceEl) priceEl.style.opacity = '0.4';
  }
  function optimisticRemove(line) {
    var lineEl = document.querySelector('[data-line-el="' + line + '"]');
    if (lineEl) {
      lineEl.style.transition = 'opacity 0.18s, transform 0.18s';
      lineEl.style.opacity = '0';
      lineEl.style.transform = 'translateX(14px)';
      lineEl.style.pointerEvents = 'none';
    }
  }

  function changeLine(line, qty) {
    var lineKey = String(line);
    if (busyLines[lineKey]) return;
    busyLines[lineKey] = true;
    if (qty <= 0) { optimisticRemove(line); } else { optimisticQty(line, qty); }
    fetch((window.AN && window.AN.cartChangeUrl) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCart(cart);
      if (document.querySelector('[data-cart-page]')) location.reload();
    })
    .catch(function () { busyLines[lineKey] = false; fetchCart(); });
  }

  function initCartDrawer() {
    drawer = document.querySelector('[data-cart-drawer]');
    overlay = document.querySelector('[data-drawer-overlay]');
    if (drawer) fetchCart();
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var opener = t.closest('[data-cart-open]');
      if (opener) { e.preventDefault(); openDrawer(); fetchCart(); return; }
      var qtyBtn = t.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        var line = qtyBtn.getAttribute('data-line');
        var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        if (qty < 0) qty = 0;
        changeLine(line, qty);
        return;
      }
      var rm = t.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-line'), 0); return; }
      var buyNow = t.closest('[data-buy-now]');
      if (buyNow) {
        e.preventDefault();
        var formId = buyNow.getAttribute('data-form-id');
        var form = (formId && document.getElementById(formId)) || buyNow.closest('form');
        if (!form) { window.location.href = '/checkout'; return; }
        buyNow.disabled = true;
        var origText = buyNow.textContent;
        buyNow.textContent = 'Taking you to checkout…';
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'add failed'); });
            return r.json();
          })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { buyNow.disabled = false; buyNow.textContent = origText; });
        return;
      }
      var closer = t.closest('[data-cart-close]'); if (closer) closeDrawer();
    });
    overlay && overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---- Product forms ---- */
  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (container) {
      var json = container.querySelector('[data-product-json]');
      if (!json) return;
      var product = JSON.parse(json.textContent);
      var form = container.querySelector('form[data-form]');
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-atc]');
      var btnText = btn ? btn.querySelector('span') : null;
      var submitting = false;
      function currentVariant() {
        var opts = [];
        container.querySelectorAll('[data-option-index]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
        });
        return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }
      /* NOTE: price/compare-price display is owned exclusively by the inline script in
         sections/main-product.liquid (updateForVariant). This function used to also write
         priceEl/compareEl here, which raced with that script on every variant change and
         produced garbled/duplicated price text. Only the variant id + button state are
         kept in sync here; the gallery image swap is also left to main-product.liquid. */
      function update() {
        var v = currentVariant();
        if (!v) { if (btn) { btn.disabled = true; if (btnText) btnText.textContent = 'Unavailable'; } return; }
        var vAvailable = v.available; var vId = v.id;
        idInput.value = vId;
        if (btn) { btn.disabled = !vAvailable; if (btnText) btnText.textContent = vAvailable ? 'Add to cart' : 'Sold out'; }
        var url = new URL(window.location); url.searchParams.set('variant', vId); history.replaceState({}, '', url);
      }
      container.querySelectorAll('[data-option-index] input').forEach(function (input) { input.addEventListener('change', update); });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitting) return;
        submitting = true; var added = false;
        if (btn) { btn.disabled = true; if (btnText) btnText.textContent = 'Adding…'; }
        fetch((window.AN && window.AN.cartAddUrl) || '/cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); added = true; return fetchCart(); })
          .then(function () { openDrawer(); })
          .catch(function () { if (!added) form.submit(); })
          .then(function () { submitting = false; if (btn) { btn.disabled = false; if (btnText) btnText.textContent = 'Add to cart'; } });
      });
      container.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var input = form.querySelector('input[name="quantity"]');
          var val = Math.max(1, parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-step'), 10));
          input.value = val;
        });
      });
    });
  }

  /* ---- Load more ---- */
  function initLoadMore() {
    var btn = document.querySelector('[data-load-more]');
    if (!btn) return;
    function loadNext() {
      var next = btn.getAttribute('data-next-url');
      if (!next || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading'); var label = btn.textContent; btn.textContent = 'Loading…';
      fetch(next).then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-product-grid]');
          var grid = document.querySelector('[data-product-grid]');
          if (newGrid && grid) { while (newGrid.firstElementChild) { grid.appendChild(newGrid.firstElementChild); } initReveal(grid); initCardClicks(grid); }
          var newBtn = doc.querySelector('[data-load-more]');
          if (newBtn && newBtn.getAttribute('data-next-url')) {
            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            btn.textContent = label; btn.classList.remove('is-loading');
          } else { btn.parentElement && btn.parentElement.removeChild(btn); io && io.disconnect(); }
          var counter = document.querySelector('[data-shown-count]');
          if (counter && grid) counter.textContent = grid.children.length;
        }).catch(function () { window.location.href = next; });
    }
    btn.addEventListener('click', loadNext);
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) loadNext();
      }, { rootMargin: '400px' });
      io.observe(btn);
    }
  }

  /* ---- Parallax ---- */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var media = document.querySelector('[data-parallax]');
    if (!media) return;
    media.style.willChange = 'transform';
    var ticking = false;
    var maxScroll = window.innerHeight * 1.2;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y < maxScroll) media.style.transform = 'translate3d(0,' + (y * 0.18).toFixed(2) + 'px,0)';
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---- Recently viewed ---- */
  var RV_KEY = 'an_rv';
  function trackRecentlyViewed(data) {
    try {
      var rv = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      rv = rv.filter(function (p) { return p.handle !== data.handle; });
      rv.unshift(data);
      localStorage.setItem(RV_KEY, JSON.stringify(rv.slice(0, 10)));
    } catch (e) {}
  }
  function initRecentlyViewed() {
    var wrap = document.querySelector('[data-recently-viewed]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-rv-grid]');
    if (!grid) return;
    var current = wrap.getAttribute('data-current-handle');
    try {
      var rv = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      rv = rv.filter(function (p) { return p.handle !== current; }).slice(0, 4);
      if (!rv.length) { wrap.hidden = true; return; }
      grid.innerHTML = rv.map(function (p) {
        return '<article class="card"><div class="card__media"><a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="750"></a></div><div class="card__info"><h3 class="card__title"><a class="card__link" href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3><div class="card__price">' + esc(p.price) + '</div></div></article>';
      }).join('');
      initReveal(wrap);
      initCardClicks(wrap);
    } catch (e) { wrap.hidden = true; }
  }
  function initProductTracking() {
    var pjson = document.querySelector('[data-product-json]');
    if (!pjson) return;
    try {
      var p = JSON.parse(pjson.textContent);
      var img = '';
      if (p.featured_image) {
        var src = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
        img = src.split('?')[0] + '?width=600';
      }
      trackRecentlyViewed({ handle: p.handle, title: p.title, url: '/products/' + p.handle, image: img, price: formatMoneyShort(p.price_min) });
    } catch (e) {}
  }

  /* ---- Product recommendations ---- */
  function initRecommendations() {
    var wrap = document.querySelector('[data-recs]');
    if (!wrap) return;
    var id = wrap.getAttribute('data-product-id');
    if (!id) return;
    var grid = wrap.querySelector('[data-recs-grid]');
    if (!grid) return;
    fetch('/recommendations/products.json?product_id=' + id + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length) { wrap.hidden = true; return; }
        grid.innerHTML = data.products.map(function (p) {
          var imgSrc = p.featured_image ? String(p.featured_image).split('?')[0] + '?width=600' : '';
          var price = p.compare_at_price_min && p.compare_at_price_min > p.price_min
            ? '<s>' + formatMoneyShort(p.compare_at_price_min) + '</s> ' + formatMoneyShort(p.price_min)
            : formatMoneyShort(p.price_min);
          return '<article class="card"><div class="card__media"><a href="' + esc(p.url) + '">' +
            (imgSrc ? '<img src="' + esc(imgSrc) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="750">' : '') +
            '</a></div><div class="card__info"><h3 class="card__title"><a class="card__link" href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3><div class="card__price">' + price + '</div></div></article>';
        }).join('');
        initReveal(wrap);
        initCardClicks(wrap);
      })
      .catch(function () { wrap.hidden = true; });
  }

  /* ---- Predictive Search ---- */
  function initSearch() {
    var searchOverlay = document.querySelector('[data-search-overlay]');
    if (!searchOverlay) return;
    var input = searchOverlay.querySelector('[data-search-input]');
    var resultsEl = searchOverlay.querySelector('[data-search-results]');
    var emptyEl = searchOverlay.querySelector('[data-search-empty]');
    var hintEl = searchOverlay.querySelector('[data-search-hint]');
    var loadingEl = searchOverlay.querySelector('[data-search-loading]');
    var fullLink = searchOverlay.querySelector('[data-search-full-link]');
    var debounceTimer = null;
    var lastQuery = '';

    function openSearch() {
      searchOverlay.hidden = false;
      document.body.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function closeSearch() {
      searchOverlay.hidden = true;
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var mobileNav = document.querySelector('[data-mobile-nav]');
        var burger = document.querySelector('[data-burger]');
        if (mobileNav) { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
        if (burger) burger.setAttribute('aria-expanded', 'false');
        openSearch();
      });
    });

    searchOverlay.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchOverlay.hidden) closeSearch();
    });

    function showHint() {
      if (hintEl) hintEl.hidden = false;
      if (resultsEl) resultsEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (loadingEl) loadingEl.hidden = true;
    }
    function showLoading() {
      if (hintEl) hintEl.hidden = true;
      if (resultsEl) resultsEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (loadingEl) loadingEl.hidden = false;
    }
    function showResults(html) {
      if (hintEl) hintEl.hidden = true;
      if (loadingEl) loadingEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (resultsEl) { resultsEl.innerHTML = html; resultsEl.hidden = false; }
    }
    function showEmpty(q) {
      if (hintEl) hintEl.hidden = true;
      if (loadingEl) loadingEl.hidden = true;
      if (resultsEl) resultsEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      if (fullLink) fullLink.href = '/search?q=' + encodeURIComponent(q);
    }

    function renderProducts(products, q) {
      if (!products || !products.length) { showEmpty(q); return; }
      var html = products.map(function (p) {
        var imgTag = p.featured_image && p.featured_image.url
          ? '<img class="search-result__img" src="' + esc(p.featured_image.url + '&width=112') + '" alt="' + esc(p.title) + '" width="56" height="56" loading="lazy">'
          : '<div class="search-result__img-ph"></div>';
        var priceHtml = '';
        if (p.price) {
          var priceCents = Math.round(parseFloat(p.price) * 100);
          var compareCents = p.compare_at_price ? Math.round(parseFloat(p.compare_at_price) * 100) : 0;
          if (compareCents && compareCents > priceCents) {
            priceHtml = '<s>' + formatMoneyShort(compareCents) + '</s> ' + formatMoneyShort(priceCents);
          } else {
            priceHtml = formatMoneyShort(priceCents);
          }
        }
        return '<a class="search-result" href="' + esc(p.url) + '">' +
          imgTag +
          '<div class="search-result__info"><p class="search-result__title">' + esc(p.title) + '</p>' +
          (priceHtml ? '<p class="search-result__price">' + priceHtml + '</p>' : '') +
          '</div></a>';
      }).join('');
      html += '<a class="search-overlay__view-all" href="/search?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo; &rarr;</a>';
      showResults(html);
    }

    function doSearch(q) {
      if (!q) { showHint(); return; }
      if (q === lastQuery) return;
      lastQuery = q;
      showLoading();
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products;
          renderProducts(products, q);
        })
        .catch(function () { showEmpty(q); });
    }

    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (!q) { lastQuery = ''; showHint(); return; }
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { doSearch(q); }, 220);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var q = input.value.trim();
          if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
        }
      });
    }
  }

  /* ---- Init ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal(); initHeader(); initMarquee(); initCarousels();
    initCartDrawer(); initProductForms(); initParallax(); initLoadMore();
    initVideos(); initProductTracking(); initRecentlyViewed(); initRecommendations();
    initSearch(); initCardClicks();
  });
})();
